import { render } from "./billManage_backup.vue?vue&type=template&id=4dfb0bc7&scoped=true"
import script from "./billManage_backup.vue?vue&type=script&lang=js"
export * from "./billManage_backup.vue?vue&type=script&lang=js"

import "./billManage_backup.vue?vue&type=style&index=0&id=4dfb0bc7&lang=scss&scoped=true"
import "./billManage_backup.vue?vue&type=style&index=1&id=4dfb0bc7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfb0bc7"]])

export default __exports__